<template>
  <div class="intergral-bg" @click.stop>
    <img class="close-icon" src="@@/assets/imgs/detail_close.png" @click="close" />
    <div class="title">填写手机号</div>
    <div class="content">
      <span>请输入您要绑定的移动手机号</span>
      <input ref="inputRef" v-model="inputVal" type="text" />
    </div>
    <div class="footer">
      <div class="confirm" @click="confirm">下一步</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { showToast } from "vant";
import { defineEmits } from "vue";
import sdkorlyjump from "~/utils/sdkorlyjump";
import { surephone } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";

const emit = defineEmits(["close", "failPrice"]);
const inputVal = ref("");
const inputRef = ref(null);
onMounted(() => {
  inputRef.value.focus();
});
/**
 * @description 去开通会员
 * @return {void}
 */
const confirm = () => {
  let reg = /^134[0-8]\d{7}$|^(?:13[5-9]|147|15[0-27-9]|178|18[2-478])\d{8}$/;
  if (!reg.test(inputVal.value)) {
    showToast("请使用移动手机号进行绑定");
    return;
  }
  desc.value = "";

  const { onSuccess ,onError} = useRequest(()=>{return surephone({ mobile: inputVal.value })})
  onSuccess((res)=>{
    if(res?.data?.code === 200){
      sdkorlyjump("", res?.data?.data?.authPage);
    }else{
      close();
      emit("failPrice", res?.data?.code, res?.data.data);
      inputVal.value = "";
    }
  })
  onError((err)=>{
    close();
    emit("failPrice", err?.data?.code, err?.data);
    inputVal.value = "";
  })

};
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = () => {
  emit("close");
};
const desc = ref("");
</script>
<style scoped lang="scss">
.intergral-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .close-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
  }

  .title {
    margin: 0.65rem 0 1.24rem 0;
    text-align: center;
    font-size: 0.685rem;
    font-weight: 600;
  }

  .content-error {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
  }

  .content {
    color: #000;
    font-size: 0.54rem;
    padding: 0 1rem;

    input {
      height: 1.7rem;
      width: calc(13.25rem - 2rem);
      padding: 0 0.5rem;
      margin-top: 1rem;
      border-radius: 0.5rem;
      line-height: 0.68rem;
      background: #f5f5f5;
      margin-right: 0.1rem;
      font-size: 0.58rem;
      border: none; /* 隐藏边框 */
      outline: none; /* 隐藏默认的焦点边框 */
      caret-color: #000; /* 设置竖线的颜色 */
    }

    input::placeholder {
      font-size: 0.7rem;
    }

    input::focus {
      border: none; /* 保持边框隐藏 */
      outline: none; /* 保持默认的焦点边框隐藏 */
      box-shadow: none; /* 防止一些浏览器添加阴影 */
    }
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1.3rem 0 0.88rem 0;
    }
  }
}
</style>
